// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bh_dt";
export var articleInfoItem = "bh_dv";
export var itemChild = "bh_dw";